import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { PLACEHOLDER } from "./constants";
import isNil from "lodash/isNil";

interface ValueCellProps {
  value: unknown;
  muted?: boolean;
}

export function ValueCell(props: ValueCellProps) {
  const { value, muted = false } = props;
  const color = muted ? "text.secondary" : undefined;

  if (isNil(value)) {
    return (
      <Text inline variant="body2" color={color}>
        {PLACEHOLDER}
      </Text>
    );
  }

  if (typeof value === "string") {
    return (
      <Text inline variant="body2" color={color} sx={{ overflowWrap: "anywhere" }}>
        {value.trim() === "" ? PLACEHOLDER : value}
      </Text>
    );
  }

  if (Array.isArray(value) || typeof value === "object") {
    return (
      <Box
        component="pre"
        sx={{
          color,
          fontFamily: "monospace",
          fontSize: "0.75rem",
          margin: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {JSON.stringify(value, null, 2)}
      </Box>
    );
  }

  return (
    <Text inline variant="body2" color={color}>
      {String(value)}
    </Text>
  );
}
